import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { API_URL } from "./constants";

// Create the HTTP link
const httpLink = createHttpLink({
  uri: API_URL,
});

// Auth link to add the token to every request
const authLink = setContext((_, { headers }) => {
  // Get the token from local storage
  const token = localStorage.getItem("auth.leadgen.eventegration.com");

  // Return the updated headers
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

// Create the Apollo Client
const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          applicants: {
            // Merge function for applicants query results
            merge(existing = [], incoming) {
              return incoming;
            },
          },
          stands: {
            // Merge function for stands query results
            merge(existing = [], incoming) {
              return incoming;
            },
          },
        },
      },
    },
  }),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "network-only",
      errorPolicy: "all",
    },
    query: {
      fetchPolicy: "network-only",
      errorPolicy: "all",
    },
    mutate: {
      errorPolicy: "all",
    },
  },
});

export default client;
